import React from 'react';
import { Box } from '@mui/material';
import { MetricCards, type MetricCardData } from './MetricCards';

interface ReportMetricsBarProps {
  metrics: MetricCardData[];
  loading?: boolean;
}

/**
 * ReportMetricsBar - thin wrapper around MetricCards to provide a consistent
 * metrics row layout for all report pages.
 */
export const ReportMetricsBar: React.FC<ReportMetricsBarProps> = ({ metrics, loading }) => {
  if (!metrics.length) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <MetricCards metrics={metrics} loading={loading} />
    </Box>
  );
};
